import { string } from "yup";

export const policyNumber = () =>
  string()
    .required("Policy number is required")
    .test("Digits only", "Policy number must be digits only", (value) => {
      if (!value) return false;
      return /^\d+$/.test(value);
    });
